/**
 * Csv Schema of RequestSsw
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {RequestSsw} from '@/model/resource/RequestSsw'

/* TODO: review generated schema */
export class CsvRequestSswSchema extends Schema {
  readonly name = 'CsvRequestSsw'

  readonly fieldSet: FieldSet<RequestSsw> = {
    idRequestPk: schema => schema.model.idRequestPk,
    notaFiscal: schema => schema.model.notaFiscal,
    json: schema => schema.model.json,
  }
}
